const CalculationListStore = {
  namespaced: true,

  state() {
    return {
      currentPage: 1,
      perPage: 50,
      searchText: '',
      expandedRows: new Set(),
      focusedRowUid: null
    }
  },

  mutations: {
    SET_CURRENT_PAGE(state, page) {
      state.currentPage = page
    },

    SET_PER_PAGE(state, perPage) {
      state.perPage = perPage
    },

    SET_SEARCH_TEXT(state, searchText) {
      state.searchText = searchText
    },

    SET_EXPANDED_ROWS(state, expandedRows) {
      state.expandedRows = new Set(expandedRows)
    },

    ADD_EXPANDED_ROW(state, uid) {
      const newExpandedRows = new Set(state.expandedRows)
      newExpandedRows.add(uid)
      state.expandedRows = newExpandedRows
    },

    REMOVE_EXPANDED_ROW(state, uid) {
      const newExpandedRows = new Set(state.expandedRows)
      newExpandedRows.delete(uid)
      state.expandedRows = newExpandedRows
    },

    CLEAR_EXPANDED_ROWS(state) {
      state.expandedRows = new Set()
    },

    SET_FOCUSED_ROW(state, uid) {
      state.focusedRowUid = uid
    },

    CLEAR_FOCUSED_ROW(state) {
      state.focusedRowUid = null
    }
  },

  actions: {
    setCurrentPage({ commit }, page) {
      commit('SET_CURRENT_PAGE', page)
    },

    setPerPage({ commit }, perPage) {
      commit('SET_PER_PAGE', perPage)
    },

    setSearchText({ commit }, searchText) {
      commit('SET_SEARCH_TEXT', searchText)
    },

    toggleExpandedRow({ state, commit }, uid) {
      if (state.expandedRows.has(uid)) {
        commit('REMOVE_EXPANDED_ROW', uid)
      } else {
        commit('ADD_EXPANDED_ROW', uid)
      }
    },

    clearExpandedRows({ commit }) {
      commit('CLEAR_EXPANDED_ROWS')
    },

    setFocusedRow({ commit }, uid) {
      commit('SET_FOCUSED_ROW', uid)
    },

    clearFocusedRow({ commit }) {
      commit('CLEAR_FOCUSED_ROW')
    }
  },

  getters: {
    getCurrentPage: (state) => state.currentPage,
    getPerPage: (state) => state.perPage,
    getSearchText: (state) => state.searchText,
    getExpandedRows: (state) => state.expandedRows,
    getFocusedRowUid: (state) => state.focusedRowUid,
    isRowExpanded: (state) => (uid) => state.expandedRows.has(uid),
    isRowFocused: (state) => (uid) => state.focusedRowUid === uid
  }
}

export default CalculationListStore